import * as React from 'react';
import Login from 'ant-design-pro/lib/Login';
import { Alert } from 'antd';

const { Tab, UserName, Password, Submit } = Login;

import 'ant-design-pro/dist/ant-design-pro.css';
import './LoginForm.css';

interface LoginFormProps {
  handleLogin: (username: string, password: string) => void;
  isAuthorizing: boolean;
  authorizationError: Error | null;
}

export default class LoginForm extends React.Component<LoginFormProps> {
  state = {
    notice: '',
    type: 'tab1',
    autoLogin: true
  };
  onSubmit = (err: any, values: { username: string; password: string }) => {
    // console.log(err, values);
    this.props.handleLogin(values.username, values.password);
  };
  onTabChange = (key: any) => {
    this.setState({
      type: key
    });
  };
  changeAutoLogin = (e: any) => {
    this.setState({
      autoLogin: e.target.checked
    });
  };
  render() {
    return (
      <div style={{ width: '368px', margin: '0 auto' }}>
        <Login
          defaultActiveKey={this.state.type}
          onTabChange={this.onTabChange}
          onSubmit={this.onSubmit}
        >
          <Tab key="tab1" tab="">
            {this.props.authorizationError && (
              <Alert
                style={{ marginBottom: 24 }}
                message={this.props.authorizationError.message}
                type="error"
                showIcon={true}
                closable={false}
                onClose={() => this.setState({ notice: '' })}
              />
            )}
            <UserName name="username" />
            <Password name="password" />
          </Tab>
          <div>
            {/* <Checkbox
              checked={this.state.autoLogin}
              onChange={this.changeAutoLogin}
            >
              Keep me logged in
            </Checkbox> */}
            {/* <a style={{ float: 'right' }} href="">
              Zapomenuté heslo
            </a> */}
          </div>
          <Submit loading={this.props.isAuthorizing}>Login</Submit>
          {/* <div>
            Other login methods
            <span className="icon icon-alipay" />
            <span className="icon icon-taobao" />
            <span className="icon icon-weibo" />
            <a style={{ float: 'right' }} href="">
              Register
            </a>
          </div> */}
        </Login>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/antd/components/login/LoginForm.tsx